import { RESTORE_RULE } from '../constants'

export default index => ({
    type: RESTORE_RULE,
    index
})
